/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiLanderRequestPayloadFromJSON(json) {
    return ApiLanderRequestPayloadFromJSONTyped(json, false);
}
export function ApiLanderRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'canonical': !exists(json, 'canonical') ? undefined : json['canonical'],
        'componentId': !exists(json, 'componentId') ? undefined : json['componentId'],
        'componentName': !exists(json, 'componentName') ? undefined : json['componentName'],
        'deferIncendiumjs': !exists(json, 'deferIncendiumjs') ? undefined : json['deferIncendiumjs'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'noIndex': !exists(json, 'noIndex') ? undefined : json['noIndex'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'subdomainId': !exists(json, 'subdomainId') ? undefined : json['subdomainId'],
    };
}
export function ApiLanderRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'canonical': value.canonical,
        'componentId': value.componentId,
        'componentName': value.componentName,
        'deferIncendiumjs': value.deferIncendiumjs,
        'description': value.description,
        'noIndex': value.noIndex,
        'path': value.path,
        'subdomainId': value.subdomainId,
    };
}
